import React from 'react';
import Grid from './common/Grid';
import AddressCard from './AddressCard';
import './AddressGrid.css';

const AddressGrid = ({ addresses, onAddClick, onEdit, onDelete, onAddressClick }) => {
  return (
    <Grid
      items={addresses}
      renderCard={(address) => (
        <AddressCard
          address={address}
          onEdit={onEdit}
          onDelete={onDelete}
          onClick={onAddressClick}
        />
      )}
      onAddClick={onAddClick}
      square={true}
    />
  );
};

export default AddressGrid;
